// extracted by mini-css-extract-plugin
export default {"headerContainer":"StatHeader_headerContainer__LT+K1","headerWrapper":"StatHeader_headerWrapper__tFP7Y"};